import React, { HTMLAttributes, useState } from "react";

// Import Swiper React components
import { Swiper, SwiperSlide, type SwiperClass } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Controller } from "swiper/modules";

import ListPoint from "../../atoms/listPoint";

interface IWhoIsDesktopSwiper {}

export const WHO_IS_LIST_TEXT = [
  {
    chinese_text: "不斷研發和引進最新技術，提升充電效率 ｡",
    english_text:
      "Innovation: Continuously researching and introducing the latest technologies to enhance charging efficiency.",
  },
  {
    chinese_text: "致⼒於環保，⽀持可再⽣能源的使⽤ ｡",
    english_text:
      "Sustainability: Committed to environmental protection and supporting the use of renewable energy.",
  },
  {
    chinese_text: "通過國際標準安全認證，並符合最⾼規格的安全標準 ｡",
    english_text:
      "Certified to international safety standards and compliant with the highest safety requirements.",
  },
];

export const PAGINATION_LIST = [
  {
    chinese_text: "創新",
    english_text: "Innovation",
  },
  {
    chinese_text: "可持續性",
    english_text: "Sustainability",
  },
  {
    chinese_text: "安全至上",
    english_text: "Security First",
  },
];

type TWhoIsDesktopSwiperProps = IWhoIsDesktopSwiper &
  HTMLAttributes<HTMLDivElement>;

const WhoIsDesktopSwiper: React.FC<TWhoIsDesktopSwiperProps> = (props) => {
  //@ts-ignore
  const [controlledSwiper, setControlledSwiper] = useState<SwiperClass>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = () => {
    setActiveIndex(controlledSwiper?.activeIndex || 0);
  };

  const CustomPagination = () => {
    return (
      <div className="flex flex-row justify-evenly items-center gap-2">
        {PAGINATION_LIST.map((text, index) => {
          return (
            <React.Fragment key={index}>
              <div
                className={`flex flex-col font-bold text-center cursor-pointer hover:text-mainYellow ${
                  activeIndex === index ? "text-white" : "text-secondaryDark"
                }`}
                onClick={() => controlledSwiper.slideTo(index)}
              >
                <span className="text-base laptop:text-2xl">
                  {text.chinese_text}
                </span>
                <span className="text-sm laptop:text-base">
                  {text.english_text}
                </span>
              </div>

              {/* Add a divider except after the last item */}
              {index < PAGINATION_LIST.length - 1 && (
                <div className="w-[1px] h-full bg-gray-400"></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-3">
      <CustomPagination />
      <Swiper
        modules={[Controller]}
        controller={{ control: controlledSwiper }}
        onSwiper={setControlledSwiper}
        onSlideChange={handleSlideChange}
        className="flex flex-1 laptop:w-[500px] h-[100px] mx-0"
      >
        {WHO_IS_LIST_TEXT.map((text, index) => {
          return (
            <SwiperSlide
              className="flex flex-row text-mainYellow gap-6"
              key={index}
            >
              <ListPoint />
              <div className="flex flex-col gap-2 text-xs laptop:text-base">
                <span className="font-bold">{text.chinese_text}</span>
                <span className="laptop:leading-6 max-w-[450px]">
                  {text.english_text}
                </span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default WhoIsDesktopSwiper;
